/* eslint-disable max-len */
import React from 'react';

const Csv = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_753_4339)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.41702 0.00244141C2.36627 0.00244141 1.51465 0.854816 1.51465 1.90519V22.0956C1.51465 23.1467 2.36627 23.9983 3.41702 23.9983H20.5823C21.6327 23.9983 22.485 23.1467 22.485 22.0956V7.61869L15.3968 0.00244141H3.41702Z'
          fill='#45B058'
        />

        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.4823 7.63182V8.00682H17.6819C17.6819 8.00682 15.3149 7.53432 15.3843 5.4917C15.3843 5.4917 15.4619 7.63182 17.6351 7.63182H22.4823Z'
          fill='#349C42'
        />

        <path
          opacity='0.5'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.3936 0V5.46037C15.3936 6.08138 15.8076 7.632 17.6826 7.632H22.4829L15.3936 0Z'
          fill='white'
        />

        <path
          d='M6.725 20.13C6.33167 20.13 5.965 20.025 5.625 19.815C5.285 19.605 5.01167 19.31 4.805 18.93C4.59833 18.55 4.495 18.1033 4.495 17.59C4.495 17.05 4.59833 16.5933 4.805 16.22C5.01167 15.8433 5.285 15.5567 5.625 15.36C5.965 15.16 6.33167 15.06 6.725 15.06C7.015 15.06 7.27333 15.1067 7.5 15.2C7.72667 15.29 7.92167 15.4133 8.085 15.57C8.24833 15.7233 8.38 15.8967 8.48 16.09C8.58333 16.2833 8.655 16.4833 8.695 16.69L7.73 16.74C7.66 16.49 7.53667 16.29 7.36 16.14C7.18667 15.9867 6.97167 15.91 6.715 15.91C6.49833 15.91 6.29333 15.9717 6.1 16.095C5.91 16.215 5.755 16.4 5.635 16.65C5.51833 16.8967 5.46 17.21 5.46 17.59C5.46 17.9433 5.515 18.245 5.625 18.495C5.735 18.745 5.885 18.9367 6.075 19.07C6.265 19.2033 6.47833 19.27 6.715 19.27C7.055 19.27 7.30833 19.1883 7.475 19.025C7.645 18.8583 7.73 18.63 7.73 18.34H8.695C8.695 18.6767 8.61667 18.98 8.46 19.25C8.30333 19.52 8.07667 19.735 7.78 19.895C7.48667 20.0517 7.135 20.13 6.725 20.13ZM11.9498 20.13C11.4832 20.13 11.0898 20.065 10.7698 19.935C10.4498 19.8017 10.2048 19.6183 10.0348 19.385C9.86818 19.1483 9.78151 18.8717 9.77484 18.555H10.6698C10.6832 18.8317 10.7932 19.0367 10.9998 19.17C11.2098 19.3033 11.4932 19.37 11.8498 19.37C12.0398 19.37 12.2115 19.34 12.3648 19.28C12.5215 19.22 12.6448 19.1383 12.7348 19.035C12.8282 18.9317 12.8748 18.815 12.8748 18.685C12.8748 18.5217 12.8148 18.3933 12.6948 18.3C12.5748 18.2033 12.3815 18.1183 12.1148 18.045L11.1298 17.71C10.7365 17.5767 10.4348 17.4 10.2248 17.18C10.0148 16.9567 9.90984 16.69 9.90984 16.38C9.90984 15.9833 10.0865 15.665 10.4398 15.425C10.7932 15.1817 11.2615 15.06 11.8448 15.06C12.4482 15.06 12.9132 15.1883 13.2398 15.445C13.5698 15.6983 13.7415 16.0167 13.7548 16.4H12.8398C12.8165 16.21 12.7215 16.065 12.5548 15.965C12.3915 15.8617 12.1548 15.81 11.8448 15.81C11.5548 15.81 11.3265 15.8733 11.1598 16C10.9965 16.1267 10.9148 16.27 10.9148 16.43C10.9148 16.7167 11.1615 16.93 11.6548 17.07L12.6898 17.435C13.0832 17.5617 13.3865 17.725 13.5998 17.925C13.8132 18.125 13.9198 18.3783 13.9198 18.685C13.9198 18.9317 13.8382 19.165 13.6748 19.385C13.5115 19.605 13.2815 19.785 12.9848 19.925C12.6915 20.0617 12.3465 20.13 11.9498 20.13ZM14.6335 15.19H15.7235L17.0785 19.185H16.9785L18.3335 15.19H19.4235L17.5535 20H16.4985L14.6335 15.19Z'
          fill='white'
        />
      </g>

      <defs>
        <clipPath id='clip0_753_4339'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Csv;
